<template>
    <div class="mainpage">
        <div class="whitebox">
            <h1>Manager</h1>
            <router-link to="/manager_all_user" class="allUser" title="All Users"></router-link>
            <router-link to="/manager_history" class="allResults" title="All Results"></router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "manager-home"
    }
</script>

<style scoped>
    .whitebox a{
        display:inline-block;
        margin:20px 35px;
        width:102px;
        height:102px;
    }
    .allUser{
        background:url(../../images/users.jpg) no-repeat center center;
    }
    .allResults{
        background:url(../../images/results.jpg) no-repeat center center;
    }
</style>